// Utilities
import {
  getTemplate
} from '../utilities'

export class SupafolioLookupCarousel {
  /**
     * Mount an ISBN lookup carousel to a dom element
     * @param {Object} client
     * @param {Element} domElement
     * @param {Array.<string>} isbns If below 6 the lookup reverts to grid behaviour
     * @param {number} productHits
     */
  static initCarousel (client, domElement, isbns, productHits = 10) {
    client.addLookupWidget({
      container: domElement,
      source: 'products',
      objectIDs: isbns,
      hitsPerPage: productHits,
      static: true,
      carousel: isbns.length < 6 ? false : {
        initialIndex: 2,
        pageDots: false,
        cellAlign: 'top',
        on: {
          ready: () => {
            domElement.querySelectorAll('.supafolio-grid-columns').forEach(element => {
              element.style.position = 'relative'
            })
            domElement.querySelectorAll('.js-product-grid-image-wrapper').forEach(element => {
              window.maintainSquareRatio(element)
            })
          }
        }
      },
      resultHandler (item) {
        const templateVars = {}
        if (item.image.includes('x145')) {
          item.image = item.image.replace('x145', 'x298')
        }

        if (item.image.includes('.imgix.net')) {
          const resizedImage = new URL(item.image)
          resizedImage.searchParams.append('w', 600)
          resizedImage.searchParams.append('h', 600)
          item.image = resizedImage
        }
        if (item.custom.handle && typeof item.custom.handle === 'string') {
          item.shopifyUrl = `/products/${item.custom.handle}`
        } else {
          console.error(item.isbn13 + ' : item is missing custom.handle')
        }
        let contributorNames = []
        if (item.contributors && item.contributors.length) {
          contributorNames = item.contributors.sort(function (a, b) {
            return (parseInt(a.order) > parseInt(b.order)) ? 1 : ((parseInt(b.order) > parseInt(a.order) ? -1 : 0))
          }).map(contributor => {
            return contributor.contributor.name
          })
        }
        // show just first contributor if exists
        templateVars.contributor = contributorNames.length ? contributorNames[0] : ''
        item.templateVars = templateVars
        return item
      },
      templates: {
        item: getTemplate('book-carousel')
      }
    })
  }
}
